import { render } from "./Provenance.vue?vue&type=template&id=d459dc58&scoped=true"
import script from "./Provenance.vue?vue&type=script&lang=js"
export * from "./Provenance.vue?vue&type=script&lang=js"

import "./Provenance.vue?vue&type=style&index=0&id=d459dc58&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d459dc58"]])

export default __exports__